import React, { useState, useEffect, useRef } from "react";
import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";
import { dateFormate, cellRendererCheck, fileFormatter } from "utils/columns";
import HoverImage from "react-hover-image/build";
import { Button } from "reactstrap";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import DeleteIcon from "assets/icon/icon-icon-options-delete.svg";
import DeleteHoverIcon from "assets/icon/download_hover.svg";
import { Formik, Field } from "formik";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";

const ProgramComment = (props) => {
  const API = useAxios();
  const { tenantID, coveredEntityID, onCommentEdit, refetch } = props;
  const [data, setData] = useState([]);
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commentId, setCommentId] = useState(-1);
  const formikRef = useRef();
  const fetchPatientComments = async () => {
    try {
      const { data } = await API.get(
        `/${tenantID}/Comments/ProgramComments/${coveredEntityID}`,
        {
          hideLoader: true,
        }
      );
      setData(data);
    } catch (error) { }
  };

  useEffect(() => {
    fetchPatientComments();
  }, [refetch]);

  const download = async (file) => {
    const { fileRepositoryID } = file;
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
      const res = await API.get(
        `/${tenantID}/Comments/Download/${parseInt(
          coveredEntityID
        )}/${fileRepositoryID}?access_token=${access_token}`,
        {
          responseType: "blob",
        }
      );
      if (res.request.responseType === "blob") {
        window.open(res.request.responseURL);
      }
    } catch (error) { }
  };

  const cellRenderEdit = (row) => {
    return (
      <div className="d-flex align-items-center">
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => onEdit(row)}
        >
          <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
        </Button>
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handleDeleteConfirmation(row)}
        >
          <HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt="" />
        </Button>
      </div>
    );
  };
  const onEdit = (row) => {
    onCommentEdit(row);
  };

  const columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 180,
      cellRenderer: (row) => cellRenderEdit(row),
      show: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "comments",
      text: "Notes",
      width: 180,
      show: true,
    },
    {
      dataField: "createdDate",
      text: "Created Date / Modified Date",
      width: 140,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
      show: true,
    },
    {
      dataField: "createdByID",
      text: "Created By / Modified By",
      width: 140,
      cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
      show: true,
    },
    {
      dataField: "files",
      text: "Attachments",
      width: 120,
      show: true,
      cellRenderer: (row) => fileFormatter(row, download),
    },
  ];

  const handleDeleteConfirmation = async (row) => {
    setDeleteConfirm(!isDeleteConfirm);
    if (row) setCommentId(row.commentID);
  };
  const deleteRow = async () => {
    handleDeleteConfirmation();

    let result = await API.post(
      `/${tenantID}/Comments/inactivecomment/${coveredEntityID}/${commentId}`,
      null,
      {
        hideLoader: true,
      }
    );
    if (result) {
      toast.success("Item removed successfully");
      fetchPatientComments();
    }
  };

  return (
    <>
      <Formik innerRef={formikRef} enableReinitialize={true}>
        <ReactStrapTable
          id="commnets"
          height={30 * data.length}
          columns={columns}
          data={data}
        // loading={loading}
        />
      </Formik>
      <Confirm
        isOpen={isDeleteConfirm}
        loading={loading}
        message="Are you sure you want to delete this comment?"
        onToggle={handleDeleteConfirmation}
        onCancel={handleDeleteConfirmation}
        onContinue={deleteRow}
      />
    </>
  );
};

export default ProgramComment;
